export const ADMIN_LOGIN = 'ADMIN_LOGIN'
export const ADMIN_LOGIN_SUCCESS = 'ADMIN_LOGIN_SUCCESS'
export const ADMIN_LOGIN_FAILURE = 'ADMIN_LOGIN_FAILURE'
export const ADMIN_SET_UI = 'ADMIN_SET_UI'
export const ADMIN_SET_ERROR = 'ADMIN_SET_ERROR'
export const ADMIN_SET_LOGIN_TOKEN = 'ADMIN_SET_LOGIN_TOKEN'
export const ADMIN_GET_ALL_TERMINALS = 'ADMIN_GET_ALL_TERMINALS'
export const ADMIN_GET_ALL_TERMINALS_SUCCESS = 'ADMIN_GET_ALL_TERMINALS_SUCCESS'
export const ADMIN_GET_ALL_TERMINALS_FAILURE = 'ADMIN_GET_ALL_TERMINALS_FAILURE'
export const ADMIN_SET_ACTIVE_TERMINAL = 'ADMIN_SET_ACTIVE_TERMINAL'
export const ADMIN_SAVE_TERMINAL = 'ADMIN_SAVE_TERMINAL'
export const ADMIN_SAVE_TERMINAL_SUCCESS = 'ADMIN_SAVE_TERMINAL_SUCCESS'
export const ADMIN_SAVE_TERMINAL_FAILURE = 'ADMIN_SAVE_TERMINAL_FAILURE'
export const ADMIN_SET_LOGIN_ERROR_MESSAGE = 'ADMIN_SET_LOGIN_ERROR_MESSAGE'
export const ADMIN_GET_UI_CONFIG = 'ADMIN_GET_UI_CONFIG'
export const ADMIN_SET_UI_CONFIG = 'ADMIN_SET_UI_CONFIG'
export const ADMIN_GET_UI_CONFIG_SUCCESS = 'ADMIN_GET_UI_CONFIG_SUCCESS'
export const ADMIN_GET_UI_CONFIG_FAILURE = 'ADMIN_GET_UI_CONFIG_FAILURE'
export const ADMIN_SET_UI_CONFIG_FAILURE = 'ADMIN_SET_UI_CONFIG_FAILURE'
export const ADMIN_GET_DEPARTURES = 'ADMIN_GET_DEPARTURES'
export const ADMIN_GET_DEPARTURES_SUCCESS = 'ADMIN_GET_DEPARTURES_SUCCESS'
export const ADMIN_GET_DEPARTURES_FAILURE = 'ADMIN_GET_DEPARTURES_FAILURE'
export const ADMIN_UPDATE_DEPARTURE = 'ADMIN_UPDATE_DEPARTURE'
export const ADMIN_UPDATE_DEPARTURE_FAILURE = 'ADMIN_UPDATE_DEPARTURE_FAILURE'
export const ADMIN_UPDATE_DEPARTURE_SUCCESS = 'ADMIN_UPDATE_DEPARTURE_SUCCESS'
export const ADMIN_TOGGLE_OPENING_LOCATION_SETTINGS = 'ADMIN_TOGGLE_OPENING_LOCATION_SETTINGS'
export const ADMIN_TOGGLE_OPENING_TERMINALS = 'ADMIN_TOGGLE_OPENING_TERMINALS'
export const ADMIN_TOGGLE_OPENING_DEPARTURES = 'ADMIN_TOGGLE_OPENING_DEPARTURES'
export const ADMIN_GET_PAIRS = 'ADMIN_GET_PAIRS'
export const ADMIN_GET_PAIRS_FAILURE = 'ADMIN_GET_PAIRS_FAILURE'
export const ADMIN_GET_PAIRS_SUCCESS = 'ADMIN_GET_PAIRS_SUCCESS'
